import { TmTableError } from '@/core/error/table/tmTableError'

export class TmTableColumnError extends TmTableError {
  public name = 'TmTableColumnError'
}
